(function () {
  'use strict';

  /* ==============================
     DRAWER
     ============================== */
  var drawerNav = document.getElementById('tt-drawer-nav');
  var menuBtn   = document.querySelector('.tt-header__menu-btn');
  var closeBtn  = document.querySelector('.tt-drawer__close');
  var overlay   = document.querySelector('.tt-drawer__overlay');

  function openDrawer() {
    if (!drawerNav) return;
    drawerNav.setAttribute('aria-hidden', 'false');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 320);
  }
  function closeDrawer() {
    if (!drawerNav) return;
    drawerNav.setAttribute('aria-hidden', 'true');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (menuBtn) menuBtn.focus();
  }
  if (menuBtn)  menuBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ==============================
     CATEGORIES DROPDOWN IN DRAWER
     ============================== */
  var catToggle = document.getElementById('tt-cat-toggle');
  var catDropdown = document.getElementById('tt-cat-dropdown');

  if (catToggle && catDropdown) {
    catToggle.addEventListener('click', function () {
      var open = catDropdown.classList.toggle('tt-cat-dropdown--open');
      catToggle.setAttribute('aria-expanded', open);
    });
  }

  /* ==============================
     SEARCH BAR TOGGLE
     ============================== */
  var searchBtn   = document.getElementById('tt-search-btn');
  var searchBar   = document.getElementById('tt-search-bar');
  var searchClose = document.getElementById('tt-search-close');
  var searchInput = searchBar ? searchBar.querySelector('.tt-search-bar__input') : null;

  function openSearch() {
    if (!searchBar) return;
    searchBar.hidden = false;
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (!searchBar) return;
    searchBar.hidden = true;
  }
  if (searchBtn)   searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* ==============================
     IMAGE GALLERY (PDP)
     ============================== */
  function initGallery() {
    var main    = document.getElementById('tt-gallery-main');
    var thumbWrap = document.querySelector('.tt-gallery__thumbs');
    if (!main) return;

    var slides = main.querySelectorAll('.tt-gallery__slide');
    var thumbs = thumbWrap ? thumbWrap.querySelectorAll('.tt-gallery__thumb') : [];

    function goTo(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('tt-gallery__slide--active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('tt-gallery__thumb--active', i === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index, 10));
      });
    });
  }
  initGallery();

  /* ==============================
     VARIANT SELECTOR (PDP)
     ============================== */
  function initVariants() {
    var form = document.getElementById('tt-product-form');
    if (!form) return;

    var productData = null;
    try {
      var dataEl = document.getElementById('tt-product-data');
      if (dataEl) productData = JSON.parse(dataEl.textContent);
    } catch (e) {}

    var optionBtns = form.querySelectorAll('[data-option-index]');
    var selectedOptions = {};

    optionBtns.forEach(function (btn) {
      var idx = btn.dataset.optionIndex;
      if (!selectedOptions[idx]) {
        var activeSibling = form.querySelector('[data-option-index="' + idx + '"].tt-size--active, [data-option-index="' + idx + '"].tt-swatch--active');
        selectedOptions[idx] = activeSibling ? activeSibling.dataset.value : (btn.dataset.value || '');
      }
    });

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = this.dataset.optionIndex;
        var val = this.dataset.value;
        selectedOptions[idx] = val;

        var siblings = form.querySelectorAll('[data-option-index="' + idx + '"]');
        siblings.forEach(function (s) {
          s.classList.remove('tt-size--active', 'tt-swatch--active');
        });
        this.classList.add(this.classList.contains('tt-swatch') ? 'tt-swatch--active' : 'tt-size--active');

        var valDisplay = document.getElementById('tt-option-val-' + idx);
        if (valDisplay) valDisplay.textContent = val;

        updateVariant(selectedOptions);
      });
    });

    function updateVariant(opts) {
      if (!productData) return;
      var optVals = Object.keys(opts).sort().map(function (k) { return opts[k]; });
      var matched = productData.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === optVals[i]; });
      });
      if (!matched) return;

      var idInput = document.getElementById('tt-variant-id');
      if (idInput) idInput.value = matched.id;

      var priceEl   = document.querySelector('.tt-pdp__price-main');
      var compareEl = document.querySelector('.tt-pdp__price-compare');
      var badgeEl   = document.querySelector('.tt-pdp__price-badge');
      var atcBtn    = document.getElementById('tt-add-to-cart');
      var atcText   = document.getElementById('tt-atc-text');

      if (priceEl) priceEl.textContent = formatMoney(matched.price);
      if (compareEl) {
        if (matched.compare_at_price > matched.price) {
          compareEl.textContent = formatMoney(matched.compare_at_price);
          compareEl.hidden = false;
          if (badgeEl) badgeEl.hidden = false;
        } else {
          compareEl.hidden = true;
          if (badgeEl) badgeEl.hidden = true;
        }
      }
      if (atcBtn) {
        if (matched.available) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('tt-pdp__atc--sold-out');
          if (atcText) atcText.textContent = 'Add to cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.classList.add('tt-pdp__atc--sold-out');
          if (atcText) atcText.textContent = 'Sold out';
        }
      }
    }

    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
  initVariants();

  /* ==============================
     ADD TO CART (AJAX)
     ============================== */
  function initAddToCart() {
    var form = document.getElementById('tt-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn    = document.getElementById('tt-add-to-cart');
      var text   = document.getElementById('tt-atc-text');
      var idInput = document.getElementById('tt-variant-id');
      var qtyInput = document.getElementById('tt-qty-input');

      if (!idInput || !idInput.value) return;

      if (btn) { btn.classList.add('tt-pdp__atc--loading'); }
      if (text) text.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(idInput.value, 10),
          quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (text) text.textContent = 'Add to cart';
        if (btn) btn.classList.remove('tt-pdp__atc--loading');
        showToast(item.title);
        updateCartCount();
      })
      .catch(function () {
        if (text) text.textContent = 'Try again';
        if (btn) btn.classList.remove('tt-pdp__atc--loading');
      });
    });
  }
  initAddToCart();

  function showToast(title) {
    var toast = document.getElementById('tt-toast');
    var toastText = document.getElementById('tt-toast-text');
    if (!toast) return;
    if (toastText) toastText.textContent = (title || 'Item') + ' added to cart';
    toast.hidden = false;
    setTimeout(function () { toast.classList.add('tt-toast--show'); }, 10);
    setTimeout(function () {
      toast.classList.remove('tt-toast--show');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 3500);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('.tt-header__cart-count');
        if (cart.item_count > 0) {
          if (!bubble) {
            var cartBtn = document.querySelector('.tt-header__cart-btn');
            if (cartBtn) {
              bubble = document.createElement('span');
              bubble.className = 'tt-header__cart-count';
              bubble.setAttribute('aria-hidden', 'true');
              cartBtn.appendChild(bubble);
            }
          }
          if (bubble) bubble.textContent = cart.item_count;
        } else if (bubble) {
          bubble.remove();
        }
      });
  }


  /* ==============================
     HERO SLIDESHOW
     ============================== */
  function initHeroSlideshow() {
    var slider = document.getElementById('tt-hero-slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.tt-hero__slide');
    var dots   = slider.querySelectorAll('.tt-hero__dot');
    if (slides.length < 2) return;

    var current  = 0;
    var interval = parseInt(slider.closest('.tt-hero') ? 5000 : 5000, 10);

    // Read interval from data attribute set by Liquid
    var heroSection = slider.closest('section');
    if (heroSection && heroSection.dataset.interval) {
      interval = parseInt(heroSection.dataset.interval, 10) * 1000;
    }

    function goTo(index) {
      slides[current].classList.remove('tt-hero__slide--active');
      if (dots[current]) {
        dots[current].classList.remove('tt-hero__dot--active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('tt-hero__slide--active');
      if (dots[current]) {
        dots[current].classList.add('tt-hero__dot--active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    var timer = setInterval(function () { goTo(current + 1); }, interval);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(parseInt(this.dataset.index, 10));
        timer = setInterval(function () { goTo(current + 1); }, interval);
      });
    });

    // Pause on hover
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', function () {
      timer = setInterval(function () { goTo(current + 1); }, interval);
    });
  }
  initHeroSlideshow();

  /* ==============================
     QUANTITY BUTTONS (PDP)
     ============================== */
  var qtyInput = document.getElementById('tt-qty-input');
  var qtyMinus = document.getElementById('tt-qty-minus');
  var qtyPlus  = document.getElementById('tt-qty-plus');
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  /* ==============================
     ACCORDION (PDP)
     ============================== */
  document.querySelectorAll('.tt-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var bodyId   = this.getAttribute('aria-controls');
      var body     = document.getElementById(bodyId);

      this.setAttribute('aria-expanded', !expanded);
      this.classList.toggle('tt-accordion__trigger--open', !expanded);
      if (body) body.classList.toggle('tt-accordion__body--closed', expanded);
    });
  });

})();
